// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__M2mcc","Success":"Button_Success__2ZCOI","Danger":"Button_Danger__20amc"};